"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudentNovaLaunchArgs = exports.StudentNovaLaunch = exports.DefaultNovaLaunchArgs = exports.DefaultNovaLaunch = void 0;
var nova_launch_1 = require("./nova-launch");
var get_component_1 = require("../../shared/helpers/get-component");
var enums_1 = require("../../shared/enums");
// default args
var DefaultNovaLaunchArgs = {
    uuid: '4d32a753-c513-49e2-af26-e903eea40e80',
    onMessage: function () {
        return;
    },
};
exports.DefaultNovaLaunchArgs = DefaultNovaLaunchArgs;
// default args
var StudentNovaLaunchArgs = __assign(__assign({}, DefaultNovaLaunchArgs), { launchConfig: {
        context: { role: enums_1.RoleEnum.STUDENT },
        textHelpers: [enums_1.TextHelperTypeEnum.DICTIONARY], // only include dictionary
    } });
exports.StudentNovaLaunchArgs = StudentNovaLaunchArgs;
// common components
var DefaultNovaLaunch = (0, get_component_1.getComponent)(nova_launch_1.NovaLaunch, DefaultNovaLaunchArgs);
exports.DefaultNovaLaunch = DefaultNovaLaunch;
var StudentNovaLaunch = (0, get_component_1.getComponent)(nova_launch_1.NovaLaunch, StudentNovaLaunchArgs);
exports.StudentNovaLaunch = StudentNovaLaunch;
